import { createFileRoute } from "@tanstack/react-router";
import { type EvalLocation, EvalWorkspace } from "@/features/evals/EvalWorkspace";
export const Route = createFileRoute("/_authenticated/evals")({
  staticData: { access: { anyOf: ["agents.manage"] } },
  validateSearch: (search: Record<string, unknown>): EvalLocation => ({
    evalId: typeof search.evalId === "string" ? search.evalId : undefined,
    versionId: typeof search.versionId === "string" ? search.versionId : undefined,
    caseId: typeof search.caseId === "string" ? search.caseId : undefined,
    runId: typeof search.runId === "string" ? search.runId : undefined,
    trialId: typeof search.trialId === "string" ? search.trialId : undefined,
    compareRunId: typeof search.compareRunId === "string" ? search.compareRunId : undefined,
    draft: search.draft === true || search.draft === "true" || undefined,
    world: search.world === true || search.world === "true" || undefined,
  }),
  head: () => ({ meta: [{ title: "Evals · Pax.co" }] }),
  component: Page,
});
function Page() {
  const location = Route.useSearch();
  const navigate = Route.useNavigate();
  return <EvalWorkspace location={location} navigate={search => void navigate({ search })} />;
}
